<template>
    <el-container v-loading="isShowLoading">
        <el-main> 
            <el-row>
                <el-form :model="filterData" :inline="true">
                    <el-form-item>
                       <el-input v-model="filterData.agencyName" placeholder="请输入开票单位代码" @click.native="showDiyTree"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="filterData.apiCode" placeholder="请输入接口代码"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="filterData.apiName" placeholder="请输入接口名称"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="filterData.channelType" placeholder="请选择调用渠道">
                            <!-- <el-option label="--调用渠道选择--" value=""></el-option> -->
                            <el-option v-for="item in channelTypeOptions" :key="item.value" :label="item.value" :value="item.key">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="filterData.errCode" placeholder="请输入异常代码"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-date-picker v-model="requestTime" value-format="yyyy-MM-dd" type="daterange" align="right" 
                            unlink-panels range-separator="-" start-placeholder="调用日期起" end-placeholder="调用日期止"
                            :picker-options="pickerOptions" style="width: 240px;" >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="small" icon="el-icon-search" @click="onFilter">查询</el-button>
                        <el-button type="primary" size="small" icon="el-icon-refresh-left" @click="reset">重置</el-button>
                    </el-form-item>
                </el-form>
            </el-row>

            <el-table ref="singleTable" :data="recordData" highlight-current-row style="width: 100%" :height="tableHeight" @row-dblclick="onRowDblclick"
			:header-cell-style="{background:'#f5f7fa', color: 'black'}" border :stripe="stripeVisible">
                <el-table-column type="index" width="50" label="序号"></el-table-column>
                <el-table-column property="apiCode" label="接口代码" width="150"></el-table-column>
                <el-table-column property="apiName" label="接口名称" width="150">
                    <template slot-scope="scope">
                        <div class="dt" @click="columnDeal(scope.row.apiName)" >
                            {{scope.row.apiName}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column property="requestTime" label="调用时间" width="160"></el-table-column>
                <el-table-column property="channelType" label="调用渠道" width="120">
                    <template slot-scope="scope">
                        <div v-if="scope.row.channelType == '00'">
                            <i class="el-icon-monitor"></i>电脑
                        </div>
                        <div v-if="scope.row.channelType == '01'">
                            <i class="el-icon-mobile-phone"></i>安卓
                        </div>
                        <div v-else-if="scope.row.channelType == '02'">
                            <i class="el-icon-apple"></i>苹果
                        </div>
                    </template>
                </el-table-column>
                <el-table-column property="requestContent" label="请求内容" align="center" width="200" >
                    <template slot-scope="scope">
                        <div class="dt" @click="columnDeal(scope.row.requestContent)" >
                            {{scope.row.requestContent}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column property="errCode" label="异常代码" width="80"></el-table-column>
                <el-table-column property="errMsg" label="异常信息" width="200">
                    <template slot-scope="scope">
                        <div class="dt" @click="columnDeal(scope.row.errMsg)" >
                            {{scope.row.errMsg}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column property="ip" label="IP" width="150"></el-table-column>
                <el-table-column property="port" label="端口号" width="80"></el-table-column>
                <el-table-column property="appName" label="调用渠道名称" width="180"></el-table-column>
            </el-table>
            <el-row style="margin: 18px 8px">
                <el-col :span="24">
                    <pagination v-show="pagination.total/pagination.pageSize>1" layout="total, sizes, prev, pager, next, jumper"
                        :total="pagination.total" :page.sync="pagination.page" :limit.sync="pagination.pageSize"
                        @pagination="onFilter" />
                </el-col>
            </el-row>
            <tree ref="myTree" @treeCallBack="treeCallBack($event)"></tree>
            <div style="height: 60px"></div>
            
        </el-main>
    </el-container>
</template>

<script>
    import tree from "../../einv/einvmain/Tree.vue";
    let _kits, _table, fn;
    export default {
        components: {
            tree
        },
        data() {
            return {
                treeData: [],
                requestTime: this.$defaultDay,
                isShowLoading: true,
                isShowItem: false,
                pageWidth: 600,
                //页面布局相关
                layout: {
                    loading: true,
                    width: 600,
                    wd: "80%",
                    edit: false
                },
                pickerOptions: {
                    shortcuts: [
                    {
                        text: "最近一周",
                        onClick(picker) {
                        const end = new Date()
                        const start = new Date()
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                        picker.$emit("pick", [start, end])
                        },
                    },
                    {
                        text: "最近一个月",
                        onClick(picker) {
                        const end = new Date()
                        const start = new Date()
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                        picker.$emit("pick", [start, end])
                        },
                    },
                    {
                        text: "最近三个月",
                        onClick(picker) {
                        const end = new Date()
                        const start = new Date()
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                        picker.$emit("pick", [start, end])
                        },
                    },
                    ],
                },
                //数据绑定相关
                filterData: {}, //过滤信息
                recordData: [], //展示信息
                channelTypeOptions: [],
                requestStatusOptions: [],
                pagination: {
                    total: 0,
                    page: 1,
                    pageSize: 10
                }, //分页信息
                entityData: {} //具体某一项信息
            }
        },
        methods: {
            showDiyTree() {
                if (this.agentNumber > 1) {
                    var option = {
                    title: '开票单位', placeholder: '请输入开票单位名称', treeCallBack: (nodes) => {
                        if (nodes.length == 0) {
                        //this.recordDataUser[0].userId = ''
                        } else {
                        if (this.filterData.agencyCode != nodes[0].id) {
                            this.filterData.agencyName = nodes[0].label;
                            this.filterData.agencyCode = nodes[0].id
                            this.init();
                        }
                        }
                    }
                    }
                    fn = option.treeCallBack
                    this.$refs.myTree.showTree(this.treeData, this.filterData.agencyCode, option)
                }
                },
                treeCallBack(nodes) {
                if (fn != undefined) {
                    fn(nodes)
                }
                },
                initTreeData(fn_call, fn_filter) {
                _kits.api.call(
                    "AGENCYTREE",
                    {},
                    result => {
                    if (result.returnCode == "0000") {
                        fn_call(_kits.arr2TreeData(result.data, fn_filter))
                    } else {
                        this.$message.error(result.returnMsg)
                    }
                    }
                )
            },

            reset(){
                this.filterData = {};
            },
            // formatDate(row, column) {
            //     let data = row[column.property]
            //     if (data == undefined) {
            //         return ''
            //     }
            //     if (data.length > 10) {
            //         return data.substring(0, 10)
            //     }
            //     return data
            // },
            onRowDblclick(row, column, event) {
                console.log(row)
            },
            onFilter() {
                console.log(_kits.data("filterData"))
                this.filterData.requestTimeStart = this.requestTimeStart
                this.filterData.requestTimeEnd = this.requestTimeEnd
                this.layout.loading = true
                _table.load()
            },
            init() {
                this.filterData.requestTimeStart = this.requestTimeStart
                this.filterData.requestTimeEnd = this.requestTimeEnd
                _table.load()   
            },
            back() {
                //console.log("back")
                this.layout.edit = false
            }
        },
        created() {
            this.pageWidth = window.innerWidth - 200
            _kits = this.$kits()
            this.initTreeData(data => {
            var a = JSON.stringify(data);
            var b = '"type":"2"';
            this.agentNumber = eval("a.match(/" + b + "/ig).length");
            this.treeData = data
            }, a => {
            //a.disabled =    a.type =='1'     // 添加属性
            //return false
            })
            _kits.api.call(
                "GETCOLLECTION", {
                   "collectionId": "channelTypeCollection"//调用渠道下拉框
                },
                result => {
                    if (result.returnCode == "0000") {
                        console.log(">>>>>",result.data);
                        this.channelTypeOptions = result.data;
                    } else {
                        this.$message.error(result.returnMsg);
                    }
                }
            );
            _kits.api.call(
                "GETCOLLECTION", {
                   "collectionId": "requestStatusCollection"//调用状态下拉框
                },
                result => {
                    if (result.returnCode == "0000") {
                        console.log(result.data);
                        this.requestStatusOptions = result.data;
                    } else {
                        this.$message.error(result.returnMsg);
                    }
                }
            );
            _table = _kits.table(
                "QUERYLOGAPIERRLIST",
                () => {
                    return Object.assign({}, this.filterData, this.pagination)
                },
                result => {
                    this.isShowLoading = false
                    this.recordData = result.list
                    this.pagination.total = Number.parseInt(result.total)
                    this.filterData.agencyName = result.agencyName;
                    this.filterData.agencyCode = result.agencyCode;
                }
            )
            this.init()
        },
        mounted() {},
        computed: {
            requestTimeStart() {
                if (this.requestTime != undefined) {
                    return this.requestTime[0]
                }
                return ""
            },
            requestTimeEnd() {
                if (this.requestTime != undefined) {
                    return this.requestTime[1]
                }
                return ""
            },
        },
    }
</script>
<style scoped>
</style>
